import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import '../assets/sass/grayscale.scss';

class Layout extends Component {
  render() {
    const { children } = this.props;
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={data.site.siteMetadata.title}
              meta={[
                { name: 'description', content: 'Web Design by Hyper Dynamo a full service ad agency.' },
                { name: 'keywords', content: 'Hyperdynamo, Hyper Dynamo, Contract Web Design, Wisconsin, WI, Chicago, IL' },
              ]}
            >
              <html lang="en"  />
            </Helmet>
{/*      <Helmet>
          <html lang="en" />
          <title>Hyper Dynamo LLC - Web Design and Development</title>
          <meta
            name="description"
            content="Web Design and Development by Hyper Dynamo LLC a full service ad agency."
          />
          <meta
            name="Keywords"
            content="Hyperdynamo, Hyper Dynamo LLC, Contract Web Design Development, Wisconsin,  WI, Chicago, IL"
          />
        </Helmet> */}
            <div title="Hyper Dynamo LLC" id="page-top" className={'page-top'}>{children}</div>
          </>
        )}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
